/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetStorefrontCheckoutGuestRequest} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'
import {GetStorefrontCheckoutGuestResponse} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'


export const getStorefrontCheckoutGuest = (request: GetStorefrontCheckoutGuestRequest, options?: CashRequestOptions) => post<GetStorefrontCheckoutGuestRequest, GetStorefrontCheckoutGuestResponse>("/2.0/cash/get-storefront-checkout-guest", request, {...options, rejectOnError: true })